export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const UNAUTHORIZED_RESPONSE = 'UNAUTHORIZED_RESPONSE';
export const SAVE_LAST_LOCATION = 'SAVE_LAST_LOCATION';
